import React, { useState, useEffect } from 'react';
import './ImageGallery.css';

const ImageGallery = ({ onImageClick }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/images');

      if (!response.ok) {
        throw new Error('Failed to fetch images');
      }

      const data = await response.json();

      if (data.success && data.images) {
        setImages(data.images);
      }
    } catch (err) {
      console.error('Error fetching images:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Public method to refresh gallery (can be called from parent)
  const refresh = () => {
    fetchImages();
  };

  // Expose refresh method via ref
  React.useImperativeHandle(React.forwardRef(() => {}), () => ({
    refresh
  }));

  if (loading) {
    return (
      <div className="gallery-container">
        <div className="gallery-header">
          <h2>Gallery</h2>
        </div>
        <div className="gallery-loading">
          <div className="spinner"></div>
          <p>Loading gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="gallery-container">
        <div className="gallery-header">
          <h2>Gallery</h2>
        </div>
        <div className="gallery-error">
          <p>Failed to load gallery: {error}</p>
          <button onClick={fetchImages} className="retry-btn">Retry</button>
        </div>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="gallery-container">
        <div className="gallery-header">
          <h2>Gallery</h2>
        </div>
        <div className="gallery-empty">
          <p>No images yet. Create your first transformation!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <h2>Gallery ({images.length})</h2>
        <button onClick={fetchImages} className="refresh-btn">
          Refresh
        </button>
      </div>
      <div className="gallery-grid">
        {images.map((image) => (
          <div
            key={image.id}
            className="gallery-item"
            onClick={() => onImageClick(image)}
          >
            <div className="gallery-image-wrapper">
              <img src={image.image_url} alt="Transformed" />
            </div>
            <div className="gallery-item-info">
              <p className="gallery-date">
                {new Date(image.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
